import { render, staticRenderFns } from "./GetStringDialog.vue?vue&type=template&id=25b538b4&"
import script from "./GetStringDialog.vue?vue&type=script&lang=ts&"
export * from "./GetStringDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports